var map = {
	"./FacebookIcon.svg": 415,
	"./TwitterIcon.svg": 636,
	"./brand-icon-black.svg": 442,
	"./brand-icon-white.svg": 291,
	"./brand-logo-black.svg": 16,
	"./brand-logo-white.svg": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;